import raw from 'raw.macro';

export default [
  { title: 'Returning JSX', content: raw('./return.md') },
  { title: 'Element Tags', content: raw('./elements.md') },
  { title: 'Values in JSX', content: raw('./values.md') },
  { title: 'Basic Element Props', content: raw('./props.md') },
  { title: 'Using Inline Styles', content: raw('./styling.md') },
];
